module.exports = __webpack_public_path__ + "img/spinner.c4cdeb2d.svg";